// extracted by mini-css-extract-plugin
export default {"logo":"CarrierListElement_logo__5mOLY"};